import React from "react";
import ReactGA from 'react-ga4'
import { useLocation } from "react-router-dom";
import request from "../../utilities/requests";
import Layout from "../../components/Layout";
import { Grid } from "@mui/material";

import ProfileHeader from "./components/ProfileHeader";
import ProfileBody from "./components/ProfileBody";
import ProfileTour from "./components/ProfileTour";

const Profile = () => {
  const location = useLocation();
  const profileTour = location.state?.profileTour;

  const [profile, setProfile] = React.useState({});
  const [fields, setFields ] = React.useState({})
  const [loaded, setLoaded] = React.useState(false);
  const [tourActive, setTourActive] = React.useState(Boolean(profileTour));

  const tourSteps = React.useMemo(() => {
    if (!profileTour) return [];
    const steps = [];
    if (profileTour.questionGroupId) {
      steps.push({
        selector: '[data-tour="event-profile"]',
        title: "Finish your event profile",
        body: `Tap "${profileTour.questionGroupName || "your event profile"}" to answer the remaining questions.`,
      });
    }
    if (profileTour.name) {
      steps.push({
        selector: '[data-tour="profile-name"]',
        title: "Add your name",
        body: "Tap here to add your first and last name.",
      });
    }
    if (profileTour.photo) {
      steps.push({
        selector: '[data-tour="profile-photo"]',
        title: "Add a profile photo",
        body: "Tap here to add your profile photo.",
      });
    }
    return steps;
  }, [profileTour]);

  React.useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/profile", title: "Profile" });
  },[])

  React.useEffect(() => {
    if (!loaded) {
      getProfile();
      setLoaded(true);
    }
  });

  const getProfile = async () => {
    const result = await request("profile");
    if (result.success) {
      setProfile(result.profile);
      setFields(result.fields)
    }
  };

  return (
    <Layout>
      <ProfileHeader profile={profile} refresh={getProfile}/>
      <Grid container direction="column" spacing={3} alignItems="center">
        <ProfileBody
          profile={profile}
          fields={fields}
          refresh={getProfile}
          tourQuestionGroupId={profileTour?.questionGroupId}
        />
      </Grid>
      {tourActive && tourSteps.length > 0 && (
        <ProfileTour steps={tourSteps} onFinish={() => setTourActive(false)} />
      )}
    </Layout>
  );
};

export default Profile;
